<div
  [ngClass]="'chip-list chip-list--' + size"
  role="listbox"
  aria-multiselectable="false"
  aria-orientation="horizontal"
>
  <div tabindex="0" class="trap-focus-element" aria-hidden="true" (keydown)="handleKeyDown($event)"></div>
  <div *ngFor="let item of items; let index = index" class="chip-list-container">
    <crm-chip
      role="option"
      [hideLabelWhenSelected]="hideLabelWhenSelected"
      [label]="item.label"
      [icon]="item.icon"
      [selected]="item.value === selected"
      [size]="size"
      (click)="handleChipClick(item.value)"
    ></crm-chip>
    <div
      *ngIf="captureFocus"
      class="chip-list-focus-overlay"
      [class.chip-list-focus-overlay--focused]="index === focusedIndex"
    ></div>
  </div>
</div>
